module.exports = "pegasus/assets/rectoutline-facebook.png";